<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_196_1593" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="1" y="1" width="23" height="22">
      <path
        d="M17.7084 2.5H4.16669C3.75229 2.5 3.35486 2.65804 3.06183 2.93934C2.76881 3.22064 2.60419 3.60218 2.60419 4V17C2.60419 17.3978 2.76881 17.7794 3.06183 18.0607C3.35486 18.342 3.75229 18.5 4.16669 18.5H17.7084C18.1228 18.5 18.5202 18.342 18.8132 18.0607C19.1062 17.7794 19.2709 17.3978 19.2709 17V4C19.2709 3.60218 19.1062 3.22064 18.8132 2.93934C18.5202 2.65804 18.1228 2.5 17.7084 2.5Z"
        fill="white"
        stroke="white"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M22.9167 6.50098V21C22.9167 21.2652 22.8069 21.5196 22.6116 21.7071C22.4162 21.8946 22.1513 22 21.875 22H6.7724"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M6.77087 10.243L9.89587 13.0055L15.1042 7.8595" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </mask>
    <g mask="url(#mask0_196_1593)">
      <path d="M0 0H25V24H0V0Z" fill="#3377DD" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
